export default "__VITE_ASSET__1c069f05__"